import { Builder } from '@builder.io/react'

import { SKUSelectionFooterDefaults } from '@src/components/SKUSelectionFooter/SKUSelectionFooter.defaults'
import { stickyFooterBuilderConfig } from '@src/components/StickyFooter/StickyFooter.builder'

import { SKUSelectionFooter } from './SKUSelectionFooter'

Builder.registerComponent(SKUSelectionFooter, {
  name: 'SKUSelectionFooter',
  inputs: [
    {
      name: 'invalidStateMessage',
      helperText: 'Displayed when the required items are not selected in rails.',
      type: 'html',
      localized: true,
      defaultValue: SKUSelectionFooterDefaults.invalidStateMessage,
    },
    {
      name: 'buttonCopy',
      type: 'text',
      localized: true,
      defaultValue: SKUSelectionFooterDefaults.buttonCopy,
    },
    {
      name: 'heading',
      type: 'text',
      localized: true,
      defaultValue: SKUSelectionFooterDefaults.heading,
    },
    {
      name: 'redirectUrl',
      type: 'text',
      defaultValue: SKUSelectionFooterDefaults.redirectUrl,
    },
    {
      name: 'extraSkus',
      friendlyName: 'Extra SKUs',
      localized: true,
      type: 'array',
      subFields: [
        {
          name: 'sku',
          type: 'string',
        },
      ],
      defaultValue: SKUSelectionFooterDefaults.extraSkus,
    },
    {
      name: 'stickyFooterProps',
      friendlyName: 'Sticky Footer Config',
      type: 'object',
      subFields: stickyFooterBuilderConfig,
    },
  ],
})
